import {Tooltip} from '@chakra-ui/react';
import {availableClientTools,clientIconSrc} from '../client/clientTools';

export default function SupportedToolIcons({config}) {
  // Only tools a visitor can actually set up; local ones need the built package.
  const {tools}=availableClientTools(config);
  return <ul aria-label="Supported AI tools" className="mt-10 flex list-none flex-wrap items-center justify-center gap-x-3 gap-y-2 p-0 sm:gap-x-4">
    {tools.map(tool=><li key={tool.id} className="block">
      <Tooltip label={tool.label} placement="top" hasArrow openDelay={150} bg="brand.50" color="brand.900" fontSize="xs" px={3} py={2}>
        <span role="img" aria-label={tool.label} tabIndex={0} className="flex h-7 w-5 items-center justify-center rounded-sm outline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-200">
          <img src={clientIconSrc(tool)} alt="" width="16" height="16" className={`h-4 w-4 object-contain ${tool.monochrome?'invert':''}`}/>
        </span>
      </Tooltip>
    </li>)}
  </ul>;
}

